// @flow
import dist from "@turf/distance"
import { point } from "@turf/helpers"
import { Map, Record } from "immutable"
import memoize from "lru-memoize"

import Place from "./Place"
import LatLon from "../services/geo/latlon"
import { PLACE_TYPES } from "../consts/place"
import { normalizeLng } from "../services/map/coordinates"

export const MAX_RADIUS = 1000 /* in km */

const round = (num: number) => Math.round(num * 100) / 100

// hotfix, maybe do better
const getPlacesInRadiusMemoized = memoize(20)(
  (
    places: Map<string, Place>,
    lat: number,
    lng: number,
    radius: number,
    centralId: ?string,
  ): Map<string, Place> => {
    const from = point([lng, lat])
    return places
      .filter(
        item =>
          item.get("type") === PLACE_TYPES.CITY &&
          dist(from, point([item.lng, item.lat])) <= radius,
      )
      .sort((a, b) => {
        if (centralId && a.get("id") === centralId) return -1
        if (centralId && b.get("id") === centralId) return 1
        const aDist = dist(from, point([a.lng, a.lat]))
        const bDist = dist(from, point([b.lng, b.lat]))
        return (a.rank + 1) * aDist - (b.rank + 1) * bDist
      })
  },
)

const RadiusRecord = Record({
  radius: 250,
  lat: 0,
  lng: 0,
  closeCity: null,
})

export default class Radius extends RadiusRecord {
  radius: number

  lat: number

  lng: number

  closeCity: ?Place

  constructor(
    input: {
      radius?: number,
      lat?: ?number,
      lng?: ?number,
      closeCity?: ?Place,
    } = {},
  ) {
    const plain = { ...input }
    if (plain.radius > MAX_RADIUS) {
      plain.radius = MAX_RADIUS
    }
    super(plain)
  }

  getId() {
    if (this.closeCity) {
      // brno-cz-100km
      return `${this.closeCity.getId()}-${this.radius}km`
    }
    return `${round(this.lat)}-${round(normalizeLng(this.lng))}-${this.radius}km`
  }

  getSearchId() {
    return `${round(this.lat)}-${round(normalizeLng(this.lng))}-${this.radius}km`
  }

  getPlacesInRadius(places: Map<string, Place>): Map<string, Place> {
    const centralId = this.closeCity && this.closeCity.get("id")
    return getPlacesInRadiusMemoized(places, this.lat, this.lng, this.radius, centralId)
  }

  isPlaceInRadius(place: Place): boolean {
    return (
      [place.lat, place.lng, this.lat, this.lng].every(Boolean) &&
      LatLon(place.lat, place.lng).distanceTo(LatLon(this.lat, this.lng)) <= this.radius
    )
  }

  // $FlowFixMe
  static fromPlainJS(plain) {
    return new Radius({
      // $FlowFixMe
      ...plain,
      // $FlowFixMe
      closeCity: plain.closeCity ? Place.fromPlainJS(plain.closeCity) : null,
    })
  }
}
